import { Component, OnDestroy } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { catchError, EMPTY, exhaustMap, interval } from 'rxjs';
import { AnalyticsService } from '../../../services/analytics.service';
import { UserService } from '../../../services/user.service';
import { EventFeedDetailsDialogComponent } from '../../dialogs/event-feed-details-dialog/event-feed-details-dialog.component';
export interface EventData {
  ai_response?: string;
  user_message?: string;
  answer_quality?: string;
  attempt?: number;
  user_answer?: string;
  judgment_logic?: string;
  problem_statement?: string;
  correct_answer?:
    | {
        text: string;
        is_correct: boolean;
      }[]
    | null;
  [key: string]: any; // allow flexible extra properties
}

export interface AnalyticsEvent {
  event_id: string;
  ts_event: string; // ISO timestamp
  session_id: string;
  bot_name: string;
  bot_visual_name?: string | null;
  bot_id: string;
  user_id: string;
  course_id: string | null;
  event_type:
    | 'session_start'
    | 'session_end'
    | 'chat_message'
    | 'live_action'
    | string;
  event_action: string | null;
  answer_correct: boolean | null;
  question_topic: string | null;
  intent: string | null;
  bloom: string | null;
  canonical_id: string | null;
  canonical_text: string | null;
  cluster_id: string | null;
  platform: string | null;
  location_url: string;
  duration_sec: number | null;
  event_data: EventData;
  xapi: any | null;
}

@Component({
  selector: 'app-realtime-feed',
  templateUrl: './realtime-feed.component.html',
  styleUrl: './realtime-feed.component.scss',
})
export class RealtimeFeedComponent implements OnDestroy {
  subscriptions = [];
  isLoading = true;

  constructor(
    protected analyticsService: AnalyticsService,
    protected userService: UserService,
    protected nbDialogService: NbDialogService
  ) {
    this.analyticsService.realTimeEventsFeed$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('realTimeEventsFeed');
    });
    this.getChartData();

    this.subscriptions.push(
      interval(10000)
        .pipe(
          // Nächster Abruf erst, wenn der letzte zurück ist.
          exhaustMap(() =>
            this.analyticsService.getRealTimeEventsFeed().pipe(catchError(() => EMPTY))
          )
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  getChartData() {
    this.analyticsService.getRealTimeEventsFeed().subscribe();
  }

  get items(): AnalyticsEvent[] {
    return this.analyticsService.realTimeEventsFeed$.value?.items || [];
  }

  getAvatarUrl(id: string): string {
    return this.userService.getAvatar(id);
  }

  openDetailsDialog(item: AnalyticsEvent) {
    this.nbDialogService.open(EventFeedDetailsDialogComponent, {
      context: {
        item: item,
      },
      closeOnBackdropClick: true,
      closeOnEsc: true,
    });
  }
}
